(function () {
  var STORAGE_KEY = 'vimyes_wishlist_products';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateButtons();
    updateCount();
    renderWishlistPage();
  }

  function productExists(handle) {
    return getWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function addProduct(product) {
    var items = getWishlist();

    if (!product.handle) return;

    if (!productExists(product.handle)) {
      items.push(product);
      saveWishlist(items);
    }
  }

  function removeProduct(handle) {
    var items = getWishlist().filter(function (item) {
      return item.handle !== handle;
    });

    saveWishlist(items);
  }

  function toggleProduct(product) {
    if (productExists(product.handle)) {
      removeProduct(product.handle);
    } else {
      addProduct(product);
    }
  }

  function heartIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21s-7.1-4.35-9.6-8.75C.62 9.12 2.2 5.25 5.8 4.55 8.05 4.1 10.15 5.18 12 7.28c1.85-2.1 3.95-3.18 6.2-2.73 3.6.7 5.18 4.57 3.4 7.7C19.1 16.65 12 21 12 21Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  }

  function getProductDataFromElement(el) {
    return {
      handle: el.getAttribute('data-wishlist-handle'),
      title: el.getAttribute('data-wishlist-title'),
      url: el.getAttribute('data-wishlist-url'),
      image: el.getAttribute('data-wishlist-image'),
      price: el.getAttribute('data-wishlist-price')
    };
  }

  function updateButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');

    buttons.forEach(function (button) {
      var handle = button.getAttribute('data-wishlist-handle');

      if (productExists(handle)) {
        button.classList.add('is-active');
        button.setAttribute('aria-label', 'Remove from wishlist');

        var text = button.querySelector('[data-wishlist-text]');
        if (text) text.textContent = 'Saved to Wishlist';
      } else {
        button.classList.remove('is-active');
        button.setAttribute('aria-label', 'Add to wishlist');

        var textDefault = button.querySelector('[data-wishlist-text]');
        if (textDefault) textDefault.textContent = 'Add to Wishlist';
      }
    });
  }

  function updateCount() {
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    var count = getWishlist().length;

    countEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  function bindButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-wishlist-button]');
      var removeButton = event.target.closest('[data-wishlist-remove]');

      if (button) {
        event.preventDefault();
        event.stopPropagation();

        var product = getProductDataFromElement(button);
        toggleProduct(product);
      }

      if (removeButton) {
        event.preventDefault();

        var handle = removeButton.getAttribute('data-wishlist-remove');
        removeProduct(handle);
      }
    });
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');

    if (!grid) return;

    var items = getWishlist();
    grid.innerHTML = '';

    if (!items.length) {
      if (empty) empty.style.display = 'block';
      grid.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    grid.style.display = 'grid';

    items.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'vimyes-wishlist-card';

      card.innerHTML =
        '<button class="vimyes-wishlist-remove" data-wishlist-remove="' + item.handle + '" aria-label="Remove">×</button>' +
        '<a class="vimyes-wishlist-img-wrap" href="' + item.url + '">' +
          '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
        '</a>' +
        '<div class="vimyes-wishlist-info">' +
          '<a href="' + item.url + '">' +
            '<h3 class="vimyes-wishlist-product-title">' + item.title + '</h3>' +
          '</a>' +
          '<div class="vimyes-wishlist-price">' + item.price + '</div>' +
        '</div>';

      grid.appendChild(card);
    });
  }

  function init() {
    bindButtons();
    updateButtons();
    updateCount();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();